webpackJsonp([73],{

/***/ 1272:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1273);


/***/ }),

/***/ 1273:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _datetime = __webpack_require__(165);

var _datetime2 = _interopRequireDefault(_datetime);

var _pt = __webpack_require__(782);

var _pt2 = _interopRequireDefault(_pt);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_datetime2.default.lang('pt', _pt2.default);

/***/ })

},[1272]);


// WEBPACK FOOTER //
// app/datetime.pt-b11c93ae11f7cc4e82d7.js